import Session from 'javascripts/layouts/v2/Session'
import { session_path } from 'routes'

let sessionPromise: Promise<Session> | null = null

export const fetchSessionOnce = (): Promise<Session> => {
  if (!sessionPromise) {
    sessionPromise = fetch(session_path())
      .then(response => response.json())
      .catch(error => {
        sessionPromise = null
        throw error
      })
  }

  return sessionPromise
}
